import { FieldError } from '@/components/ui/field';
import { Field, FieldProps, getIn } from 'formik';

export const ConnectedFieldError = ({ name }: { name: string }) => (
  <Field name={name}>
    {({ form }: FieldProps) => {
      const isTouched = getIn(form.touched, name);
      const error = getIn(form.errors, name);
      const showError = isTouched && error;

      if (!showError) return null;

      return (
        <FieldError>
          {typeof error === 'string' ? error : JSON.stringify(error)}
        </FieldError>
      );
    }}
  </Field>
);
